import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import BodyContentStyles from './BodyContent.styled';
import Markdown from '../../Shared/Markdown/Markdown';

export const MediaPostion = {
  Left: 1,
  Right: 2,
  Top: 3,
  Bottom: 4,
};

const cleanupMarkdownImageRefs = (markdown) => {
  if (markdown) {
    //Adjust the markdown.  Images should use HTTPS.  (Also, adjust old references for contentful.com)
    markdown = markdown.replace(
      /\/\/images.ctfassets.net\//g,
      'https://images.ctfassets.net/'
    );
    markdown = markdown.replace(
      /\/\/images.contentful.com\//g,
      'https://images.ctfassets.net/'
    );

    //Adjust the markdown.  Images at w780 should be w800.
    markdown = markdown.replace(/w=780/g, 'w=800');
  }
  return markdown;
};

const BodyContent = ({
  backgroundColor = '#FFFFFF',
  disclaimer,
  markdown,
  media,
  mediaPostion = MediaPostion.Left,
}) => {
  let mediaPositionClass = '';

  if (media) {
    switch (mediaPostion) {
      case MediaPostion.Left:
        mediaPositionClass = 'media-left';
        break;

      case MediaPostion.Right:
        mediaPositionClass = 'media-right';
        break;

      case MediaPostion.Top:
        mediaPositionClass = 'media-top';
        break;

      case MediaPostion.Bottom:
        mediaPositionClass = 'media-bottom';
        break;
    }
  }

  //Adjust the markdown.
  markdown = cleanupMarkdownImageRefs(markdown);

  return (
    <BodyContentStyles
      backgroundColor={backgroundColor}
      className={`body-content ${mediaPositionClass} ${media ? 'media' : ''}`}
    >
      <div className="body-content-container">
        {media ? <Image src={media} alt="Content Media" fill /> : null}
        <div className="body-content-text">
          <Markdown markdown={markdown} />
          {disclaimer ? <p className="disclaimer">{disclaimer}</p> : null}
        </div>
      </div>
    </BodyContentStyles>
  );
};

BodyContent.propTypes = {
  backgroundColor: PropTypes.string,
  disclaimer: PropTypes.any,
  markdown: PropTypes.any,
  media: PropTypes.any,
  mediaPostion: PropTypes.any,
};

export default BodyContent;
